<div class="card mt-3">
  <div class="card-body">
    <h3 class="mb-4">{{ 'MENU.DASHBOARD.add_countries' | translate }} </h3>

  <form #jobTitleForm="ngForm" (ngSubmit)="onSubmit()" enctype="multipart/form-data">
  <div class="row">
    <!-- Job Title (English) -->
    <div class="col-sm-4">
      <div class="mb-3">
        <label class="form-label">
          {{ 'MENU.DASHBOARD.countries_name_en' | translate }}
          <span class="text-danger">*</span>
        </label>
        <input
          type="text"
          class="form-control"
          placeholder="{{ 'MENU.DASHBOARD.enter_countries_name_en' | translate }}"
          [(ngModel)]="formData.name_en"
          name="name_en"
          required
          #nameEn="ngModel"
        />
        <!-- Validation Message -->
        <div *ngIf="nameEn.invalid && nameEn.touched" class="text-danger small mt-1">
          {{ 'MENU.DASHBOARD.countries_name_en_required' | translate }}
        </div>
      </div>
    </div>

    <!-- Job Title (Arabic) -->
    <div class="col-sm-4">
      <div class="mb-3">
        <label class="form-label">
          {{ 'MENU.DASHBOARD.countries_name_ar' | translate }}
          <span class="text-danger">*</span>
        </label>
        <input
          type="text"
          class="form-control"
          placeholder="{{ 'MENU.DASHBOARD.enter_countries_name_ar' | translate }}"
          [(ngModel)]="formData.name_ar"
          name="name_ar"
          required
          #nameAr="ngModel"
        />
        <!-- Validation Message -->
        <div *ngIf="nameAr.invalid && nameAr.touched" class="text-danger small mt-1">
          {{ 'MENU.DASHBOARD.countries_name_ar_required' | translate }}
        </div>
      </div>
    </div>
  </div>

  <!-- Submit + Cancel -->
  <div class="text-start mt-3">
    <button
      type="submit"
      class="btn btn-suc px-3"
      [disabled]="jobTitleForm.invalid"
    >
      {{ 'MENU.DASHBOARD.add_countries' | translate }}
    </button>

    <button
      type="button"
      class="btn btn-secondary ms-2 mx-2 px-3"
      (click)="cancel()"
    >
      {{ 'MENU.DASHBOARD.cancel' | translate }}
    </button>
  </div>
</form>

  </div>
</div>
